'use strict';

const get = require('lodash/get');

module.exports = (function() {
  class BrowserHistoryHandler {
    static initClass() {
      this.prototype.popCallbacks = [];
    }
    constructor(id) {
      this.id = id;
      if (
        (window.history != null ? window.history.pushState : undefined) == null
      ) {
        return;
      }
      $(window).on('popstate', ({ originalEvent }) => {
        const state = originalEvent != null ? originalEvent.state : undefined;
        const data =
          get(state, 'merchantPage.coupons.doNotShow.ids') === id
            ? state.mppHistory.data
            : {};
        return this.triggerPop(data);
      });
    }
    onPop(cb) {
      this.popCallbacks.push(cb);
    }
    triggerPop(data) {
      return this.popCallbacks.map(cb => {
        cb(data);
      });
    }
    add(data) {
      if (
        (window.history != null ? window.history.pushState : undefined) == null
      ) {
        return;
      }
      const url = window.location.href.replace(/#.+$/, '');
      const mppHistory = {
        id: this.id,
        data,
      };
      history.pushState(
        {
          mppHistory,
        },
        document.title,
        url
      );
    }
  }
  BrowserHistoryHandler.initClass();
  return BrowserHistoryHandler;
})();
